import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useInit } from '../../../../Contexts/InitProvider';
import { ButtonPrimary } from '../../../../utils/Button';
import { GetDate, GetTime } from '../../../../utils/Show';
import { mkRelativeUrl } from '../../../../utils/URL';
import cn from '../../../../utils/cn';

function TableInfoCard({ name, value, isCapitalize, className }) {
    return (
        <div
            className={cn(
                'text-sm text-primary-700 font-medium flex flex-row gap-3 justify-start items-start h-auto',
                className
            )}
        >
            <p className="inline-flex justify-between items-center min-w-[112px] w-28">
                <span>{name}</span>
                <span>:</span>
            </p>
            <span
                className={cn(` text-primary font-normal text-sm`, {
                    capitalize: isCapitalize
                })}
            >
                {value}
            </span>
        </div>
    );
}

function TableRow({
    item,
    onMakeImplement,
    onMakeOngoing,
    onMakeDone,
    onMakeIteration,
    handleCreateSupportTicket,
    showActivityModal,
    initiate,
    implement,
    ongoing,
    done
}) {
    const navigate = useNavigate();
    const [isTrActive, setIsTrActive] = useState(false);

    // const isActive = item?.status === 'active';
    return (
        <div
            tabIndex={-1}
            role="button"
            onClick={() => setIsTrActive((cu) => !cu)}
            className={cn(
                `table-visible-data overflow-hidden w-full flex flex-col justify-between text-primary p-2.5 rounded-md transition-all duration-[800ms] ease-in-out remove-highlight`,
                {
                    'max-h-[500px]': isTrActive,
                    'max-h-10': !isTrActive,
                    'placeholder-mode': item.demo
                }
            )}
        >
            <div className="w-full flex flex-row gap-1 justify-between text-primary text-sm font-medium leading-normal">
                <div
                    className="min-w-[112px] w-28 cursor-pointer"
                    onClick={(e) => {
                        e.stopPropagation();
                        navigate(mkRelativeUrl(`/services/manage/${item?.id}/info`));
                    }}
                    role="button"
                    tabIndex={-1}
                >
                    <span>{item?.id}</span>
                </div>
                <div
                    className="w-full cursor-pointer"
                    onClick={(e) => {
                        e.stopPropagation();
                        navigate(mkRelativeUrl(`/services/manage/${item?.id}/info`));
                    }}
                    role="button"
                    tabIndex={-1}
                >
                    <span className="line-clamp-1">{item?.serviceName}</span>
                </div>
                <div className="w-full hidden sm:block capitalize">
                    <span
                        className={item?.status === 'completed' ? 'text-secondary' : 'text-warning'}
                    >
                        {item?.status}
                    </span>
                </div>
            </div>

            <div className="table-data-more mt-3.5 flex flex-col justify-start items-item gap-2">
                <TableInfoCard name="Product Type" value={item?.productType} isCapitalize />
                <TableInfoCard
                    name="Customer Info"
                    value={
                        <div
                            role="button"
                            tabIndex={-1}
                            onClick={() =>
                                navigate(mkRelativeUrl(`/customers/${item?.user?.id}/info`))
                            }
                        >
                            <span className="group-hover:text-secondary group-hover:font-medium cursor-pointer underline text-ellipsis block w-full overflow-hidden">
                                {item?.user?.organization || '-----'}
                            </span>
                            <span className="text-secondary text-xs lowercase overflow-hidden text-ellipsis block w-full ">
                                {item?.user?.primaryEmail}
                            </span>
                        </div>
                    }
                />
                <TableInfoCard
                    name={initiate}
                    value={
                        <span>
                            {GetDate(item?.timeInitiate) || '-----'} <br />
                            <small>{GetTime(item?.timeInitiate)}</small>
                        </span>
                    }
                />
                <TableInfoCard
                    name={implement}
                    value={
                        <span>
                            {GetDate(item?.timeImplement) || '-----'} <br />
                            <small>{GetTime(item?.timeImplement)}</small>
                        </span>
                    }
                />
                <TableInfoCard
                    name={ongoing}
                    value={
                        <span>
                            {GetDate(item?.timeOngoing) || '-----'} <br />
                            <small>{GetTime(item?.timeOngoing)}</small>
                        </span>
                    }
                />
                <TableInfoCard
                    name={done}
                    value={
                        <span>
                            {GetDate(item?.timeDone) || '-----'} <br />
                            <small>{GetTime(item?.timeDone)}</small>
                        </span>
                    }
                />
                <TableInfoCard
                    name="Updated At"
                    value={
                        <span>
                            {GetDate(item?.timeUpdated) || '-----'} <br />
                            <small>{GetTime(item?.timeUpdated)}</small>
                        </span>
                    }
                />
                <TableInfoCard
                    name="Status"
                    value={
                        <span
                            className={`${item?.status === 'completed' ? 'text-secondary' : 'text-warning'}`}
                        >
                            {item?.status}
                        </span>
                    }
                    className="visible sm:invisible"
                    isCapitalize
                />

                <div className="flex flex-row flex-wrap gap-px justify-end items-center">
                    <ButtonPrimary
                        btnType="button"
                        title="View Activity Log"
                        onClick={(ev) =>
                            ev.stopPropagation() + showActivityModal({ show: true, data: item })
                        }
                    />
                    <ButtonPrimary
                        btnType="button"
                        title="Create Support Ticket"
                        onClick={(ev) => handleCreateSupportTicket(ev, item?.user?.id, item?.id)}
                    />
                    <ButtonPrimary
                        btnType="button"
                        title="Make Iteration"
                        onClick={(ev) => onMakeIteration(ev, item)}
                    />
                    {item?.status === 'initiate' && (
                        <ButtonPrimary
                            btnType="button"
                            title={`Make ${implement}`}
                            onClick={(ev) => onMakeImplement(ev, item)}
                        />
                    )}
                    {item?.status === 'implement' && (
                        <ButtonPrimary
                            btnType="button"
                            title={`Make ${ongoing}`}
                            onClick={(ev) => onMakeOngoing(ev, item)}
                        />
                    )}
                    {item?.status !== 'completed' && (
                        <ButtonPrimary
                            btnType="button"
                            title={`Make ${done}`}
                            onClick={(ev) => onMakeDone(ev, item)}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}

function ServiceManagePageTableMobile({
    data,
    onMakeImplement,
    onMakeOngoing,
    onMakeDone,
    onMakeIteration,
    handleCreateSupportTicket,
    showActivityModal
}) {
    const { initInfo } = useInit();

    const { initiate, implement, ongoing, done } = initInfo.steps || {};
    return (
        <div className="service_page_mobile_page_table">
            <div className="table-data [&>*:nth-child(odd)]:bg-primary-50">
                {data?.servicesList && data?.servicesList?.length === 0 ? (
                    <div className="w-full text-sm font-medium p-2 rounded-5">No Data Found</div>
                ) : (
                    data?.servicesList?.map((item) => (
                        <TableRow
                            key={item.id}
                            item={item}
                            onMakeImplement={onMakeImplement}
                            onMakeOngoing={onMakeOngoing}
                            onMakeDone={onMakeDone}
                            onMakeIteration={onMakeIteration}
                            handleCreateSupportTicket={handleCreateSupportTicket}
                            showActivityModal={showActivityModal}
                            initiate={initiate}
                            implement={implement}
                            ongoing={ongoing}
                            done={done}
                        />
                    ))
                )}
            </div>
        </div>
    );
}

export default ServiceManagePageTableMobile;
